export default {
    state: {
        count: 0
    },

    mutations: {
        show(state) {
            state.count++
        },
        hide(state) {
            state.count--
        },
        cancel(state) {
            state.count = 0
        }
    },

    namespaced: true
}